import { Box, Flex, Heading, Switch, Text } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { truncate } from '../../../../utils/string.util';
import { CoupomAPI } from '../../api';
import { Coupom } from '../../models/coupom';

export type TagItemListProps = {
  data: Coupom;
  onOpenModal: (data: Coupom) => void;
};

const ItemList: FC<TagItemListProps> = ({ data, onOpenModal }) => {
  const [activeCoupom, setActiveCoupom] = useState<boolean>(
    data.customization.active_coupon,
  );

  const handleToggleVisibility = async (e: any) => {
    const coupomAPI = new CoupomAPI();
    setActiveCoupom(e.target.checked);
    await coupomAPI
      .update(data.id, {
        ...data.customization,
        active_coupon: e.target.checked,
      })
      .catch(() => setActiveCoupom(!e.target.checked));
  };

  return (
    <>
      <Flex
        shadow="md"
        h="full"
        w={{ sm: '100%', md: 'fit-content' }}
        transition="all 0.2s"
        _hover={{ transform: 'scale(1.01)', shadow: 'lg' }}
      >
        <Flex role="button" onClick={() => onOpenModal(data)}>
          <Box px={5} py={3} maxW="256px">
            <Text fontSize="x-small" fontStyle="italic" opacity="0.8">
              {data.code}
            </Text>
            <Heading as="h2" fontSize="md" fontWeight="medium" color="cyan.600">
              {data.name}
            </Heading>
            <Text
              size="sm"
              fontSize="xs"
              title={data.customization.description}
              mt="1"
            >
              {truncate(data.customization.description, 100)}
            </Text>
          </Box>
        </Flex>
        <Switch
          _active={{ outline: 'none' }}
          _focus={{ outline: 'none' }}
          size="sm"
          alignSelf="center"
          px={2}
          ml="auto"
          isChecked={activeCoupom}
          onChange={handleToggleVisibility}
        />
      </Flex>
    </>
  );
};

export default ItemList;
